// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import Uppy, { debugLogger } from "@uppy/core";
// import * as ReactDOM from "react-dom/client";
// import { v4 as uuidv4 } from "uuid";
// import AwsS3Multipart from "@uppy/aws-s3-multipart";
// import bytesToDisplayHelper from "../../../utils/bytesToDisplayHelper.js";
// import Button from "../../Elements/Button/Button.js";
// import Icon from "../../Elements/Icon/Icon.tsx";
// import useMediaQueries from "../../../hooks/useMediaQueries.js";
// import parse from "html-react-parser";
// import loader from "../../../assets/images/preloader.gif";
// import EditMailDetailsModal from "./ModalsAndPopups/EditMailDetailsModal.js";
// import EmbedErrorsModal from "./ModalsAndPopups/EmbedErrorsModal.js";
// import { useBeforeunload } from "react-beforeunload";
// import { LimitSizeModal } from "./ModalsAndPopups/LimitSizeModal.js";
// import { useModal } from "../../../contexts/modalContext/modalContext.js";
// import { useParams } from "react-router";
// import { Dashboard, useUppy } from "@uppy/react";
// import { useContent } from "../../../contexts/contentContext/contentContext.js";
// import { useUser } from "../../../contexts/userContext/userContext.js";
// import { useCookie } from "../../../contexts/cookieContext/cookieContext.js";
// import { DefaultContainerNoClose } from "../../Structure/ModalManager/DefaultContainer.js";
// import {
//   CustomUploadInfo,
//   renderAddFilesFolderButton,
//   renderAddFilesFolderButtons,
//   renderCustomDragAndDtopTitle,
//   renderErrors,
//   scrollerFunc,
//   uploadButtonRender,
//   uploadSuccessLoaderImage,
// } from "./Helpers/renderCustomDomFuncs.js";
// import {
//   beforeUploadHandler,
//   errorHandler,
//   fileUploadCompleteHandler,
//   uploadCompleteHandler,
//   embedUploadCompleteHandler,
//   fileUploadFailed,
//   checkUplaoderConnection,
// } from "./Helpers/uppyAPICallFunctions.js";
// import SimpleContent from "../../Structure/ModalManager/SimpleContent.js";
// import FinalCallModal from "./ModalsAndPopups/FinalCallModal.js";
// import { ConnectionUploaderIssue } from "./ModalsAndPopups/ConnectionUploaderIssue.js";
// import {
//   getLocalStorage,
//   removeLocalStorage,
//   setLocalStorage,
// } from "utils/globalLocalStorage.js";

// export const setLocalStorageUppy = ({
//   mailId,
//   success,
//   complete,
//   error,
//   fileError,
// }) => {
//   if (error) {
//     //in case error saving mailId with error
//     setLocalStorage(`upload-${mailId}`, "upload-error");
//   } else if (complete) {
//     //data is successfully sent by uppy, but still not approved by server
//     setLocalStorage(
//       `upload-${mailId}`,
//       `s-${complete.successful.length},e-${complete.failed.length}`
//     );
//   } else if (success) {
//     //data is successfully saved by server and we can remove record
//     removeLocalStorage(`upload-${mailId}`);
//     removeLocalStorage(`uploadError-${mailId}`);
//   } else {
//     // increasing quantity of the files on each upload/file-error
//     const keyName = !fileError ? `upload-${mailId}` : `uploadError-${mailId}`;
//     const storeVal = parseInt(getLocalStorage(keyName));
//     const newVal =
//       storeVal || storeVal === 0 ? storeVal + 1 : fileError ? 1 : 0;
//     setLocalStorage(keyName, newVal);
//   }
// };

// export const UppyComponent = ({
//   token,
//   isJMPay,
//   embedMailId = null,
//   setFinishUpload = null,
//   embedFormDetails = null,
//   embedDesign = null,
// }) => {
//   const { mailId } = useParams();
//   const encryptMailId = embedMailId ? embedMailId : mailId;
//   const { getTextByKey, getLanguageCulture, getPath, getHtmlByKey } =
//     useContent();
//   const { setCookies, removeCookies } = useCookie();
//   const { getUserData, isBusiness, isPremium } = useUser();
//   const { setModal, closeModal, getModal } = useModal();
//   const { desktopCondition } = useMediaQueries();
//   const [itsDone, setItsDone] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [filesExist, setFilesExist] = useState(false);
//   const [size, setSize] = useState(0);
//   const [filesCount, setFilesCount] = useState(0);
//   const [confirmCode, setConfirmCode] = useState(null);
//   const [errStatus, setErrStatus] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [isActive, setIsActive] = useState(true);
//   const [server, setServer] = useState(null);
//   const [hasFolders, setHasFolders] = useState(false);
//   // ref values for keepeng previous data about uploading size and speed
//   const deltaRef = useRef(0);
//   const prevSizeRef = useRef(0);
//   const totalFilesCount = useRef(null);

//   const uploadInfo = useMemo(() => {
//     return new CustomUploadInfo({ getTextByKey });
//   }, []);

//   let intervalId;

//   const getCurrentSize = useCallback(() => {
//     // detecting delta between current uploaded size and 3s ago
//     const delta = uploadInfo.getTotalUploadedSize() - prevSizeRef.current;
//     //taking avarage from prev delta and current delta and deviding it by 3s
//     const currenUploadSpeed = (delta + deltaRef.current) / 2 / 3;
//     const estimationTime =
//       (uploadInfo.getSize() - uploadInfo.getTotalUploadedSize()) /
//       currenUploadSpeed;
//     uploadInfo.renderInnerData(currenUploadSpeed, estimationTime);
//     // upadting deltaref as a current delta
//     deltaRef.current = delta;
//     // updating prevSizeRef as current total size
//     prevSizeRef.current = uploadInfo.getTotalUploadedSize();
//   }, []);

//   const handleAddFiles = () => {
//     const inputElem = document.querySelector(".uppy-Dashboard-input");
//     if (!inputElem) {
//       document.querySelector(".uppy-DashboardContent-addMore").click();
//       setTimeout(() => {
//         document.querySelector(".uppy-Dashboard-input").click();
//       }, 100);
//     } else {
//       inputElem.click();
//     }
//   };

//   const handleAddFolders = () => {
//     const inputElem = document.querySelector("[webkitdirectory]");
//     if (!inputElem) {
//       document.querySelector(".uppy-DashboardContent-addMore").click();
//       setTimeout(() => {
//         document.querySelector("[webkitdirectory]").click();
//       });
//     } else {
//       inputElem.value = "";
//       inputElem.addEventListener("input", (e) => {
//         const filesObj = {};
//         e.target.files.forEach(
//           (item) => (filesObj[item.name] = item.webkitRelativePath)
//         );
//         setTimeout(() => {
//           uppy.getFiles().forEach((file) => {
//             uppy.setFileMeta(file.id, {
//               relativePath: filesObj[file.name].replaceAll("/", "\\\\"),
//             });
//           });
//         }, 300);
//       });
//       inputElem.click();
//     }
//   };

//   useBeforeunload((e) => {
//     if (!itsDone && size > 0) {
//       // PAUSE UPLOAD TESTING
//       e.preventDefault();
//       e.returnValue = "Are yopu sure?";
//     }
//   });

//   // useEffect(() => {
//   //   const inputElem = document.querySelector("[webkitdirectory]");
//   //   if (inputElem) {
//   //     inputElem.onchange = function (e) {
//   //       dragEnter();
//   //     };
//   //   }
//   // }, []);

//   const [log, setLog] = useState({
//     err: [],
//     wrn: [],
//     ok: [],
//   });

//   const [currentLog, setCurrentLog] = useState("ok");

//   const retries = {};

//   const logger = {
//     debug: (...args) => {
//       setLog((prev) => {
//         return { ...prev, ok: [...prev.ok, args] };
//       });
//     },
//     warn: (...args) => {
//       setLog((prev) => {
//         return { ...prev, wrn: [...prev.wrn, args] };
//       });
//     },
//     error: (...args) => {
//       setLog((prev) => {
//         return { ...prev, err: [...prev.err, args] };
//       });
//     },
//   };

//   const errorFiles = [];

//   const uppy = useUppy(() => {
//     const uppy = new Uppy({
//       onBeforeUpload: (files) => {
//         setLocalStorageUppy({ mailId: mailId });
//         if (document.querySelector(".uppy-DashboardContent-addMore")) {
//           document.querySelector(
//             ".uppy-DashboardContent-addMore"
//           ).style.display = "none";
//         }
//         setUploading(true);
//         totalFilesCount.current = Object.keys(files).length;
//       },
//       debug: process.env.REACT_APP_STAGE !== "prod ",
//       logger: logger,
//       allowMultipleUploadBatches: false,
//       meta: {
//         addWatermarkToThumbnail: isJMPay,
//         addVideoWatermark: isJMPay,
//         imageratio: 1,
//         mailId: encryptMailId,
//         isEmbed: !!embedMailId,
//       },
//     });

//     const siezLimit = isBusiness() || isPremium() ? 536870912000 : 268435456000;

//     uppy.on("file-added", (file) => {
//       // handeling single file preview
//       setTimeout(() => {
//         const elem = document.querySelector(".uppy-Dashboard--singleFile");
//         if (elem) {
//           elem.classList.remove("uppy-Dashboard--singleFile");
//         }
//       });
//       if (file.size > siezLimit) {
//         uppy.removeFile(file.id);
//         setModal({
//           modal: SimpleContent,
//           props: {
//             title: getTextByKey("limit-oops-text"),
//             message: getTextByKey("single-file-limit"),
//           },
//         });
//       }
//     });

//     uppy.on("upload", (data) => {
//       setTimeout(() => {
//         uploadInfo.renderContainer();
//         document
//           .querySelector(".uppy-StatusBar-statusPrimary")
//           .classList.add("no-display");
//       }, 100);
//       intervalId = setInterval(getCurrentSize, 3000);
//       uploadInfo.setTotalFilesCount(uppy.getFiles().length);
//     });

//     uppy.on("progress", (progress) => {
//       document.title = getTextByKey("uploading-title") + ": " + progress + "%";
//     });

//     uppy.on("upload-success", (file, response) => {
//       setLocalStorageUppy({ mailId: mailId });
//       fileUploadCompleteHandler({
//         file,
//         mailId: encryptMailId,
//         serverRes: response,
//         setFilesCount,
//         uppy,
//         retries,
//       });
//       setTimeout(() => {
//         scrollerFunc(file.id);
//       }, 500);
//       uploadInfo.updateUploadedFilesCount();
//     });

//     uppy.on("complete", (result) => {
//       if (!embedMailId) {
//         setTimeout(() => {
//           setModal({
//             modal: FinalCallModal,
//             container: DefaultContainerNoClose,
//             props: {
//               callback: () =>
//                 uploadCompleteHandler({
//                   files: uppy.getFiles(),
//                   mailId: mailId,
//                   lang: getLanguageCulture(),
//                   userMail: getUserData().UserName,
//                   token,
//                   langPath: getPath(),
//                   code: confirmCode,
//                   setItsDone,
//                 }),
//             },
//           });
//         }, 2000);
//       }
//       if (document.querySelector(".files-size"))
//         document.querySelector(".files-size").style.display = "none";
//       setLocalStorageUppy({ mailId: mailId, complete: result });
//     });

//     // adding filesSize to total number to show
//     uppy.on("files-added", (files) => {
//       if (files.length === 0) {
//         handleShowSize();
//         const addFilesPanel = document.querySelector(
//           ".uppy-Dashboard-AddFilesPanel"
//         );
//         if (addFilesPanel) {
//           addFilesPanel.querySelector(".uppy-DashboardContent-back")?.click();
//         }
//       }
//       files.forEach((file) => {
//         if (file.meta.relativePath && !hasFolders) {
//           setHasFolders(true);
//         }
//         setSize((prev) => prev + file.size);
//       });
//     });

//     uppy.on("upload-progress", (file, progress) => {
//       uploadInfo.updateUploadedFileSize(file.id, progress.bytesUploaded);
//     });

//     // subtracting files size on remove
//     uppy.on("file-removed", (file, reason) => {
//       setSize((prev) => prev - file.size);
//     });

//     uppy.on("cancel-all", () => {
//       setHasFolders(false);
//       setUploading(false);
//     });

//     uppy.on("upload-retry", (fileID) => {
//       retries[fileID] = true;
//     });
//     uppy.on("error", (err) => {
//       if (!err.message.includes("Failed to upload")) {
//         setLocalStorageUppy({ mailId: mailId, error: true });
//         setErrStatus(err.message);
//         renderErrors({ getTextByKey });
//       }
//     });

//     uppy.on("upload-error", (file, error) => {
//       if (!retries[file.id]) {
//         uppy.retryUpload(file.id);
//       } else {
//         if (!errorFiles.includes(file.id)) {
//           errorFiles.push(file.id);
//           setLocalStorageUppy({ mailId: mailId, fileError: true });
//           fileUploadFailed({
//             mailId: encryptMailId,
//             file,
//             error,
//             setFilesCount,
//           });
//         }
//       }
//     });

//     const uploaderUrl =
//       process.env.REACT_APP_STAGE === "prod "
//         ? "https://up.jumbomail.me/uploads"
//         : "https://up.jumbomail.me/uploads";

//     uppy.use(AwsS3Multipart, {
//       limit: 15,
//       retryDelays: [0, 1000, 3000],
//       companionUrl: uploaderUrl,
//       getChunkSize: (file) => {
//         // default chunk size is 10 mb, in case fileSize bigger than 10000 chunks * 5mb, chunk size will be fileSize/9990
//         if (file.size > 10000 * 5000000) {
//           return file.size / 9990;
//         } else {
//           return 10000000;
//         }
//       },
//     });

//     return uppy;
//   });

//   // PROPS SECTION
//   const height = window.innerHeight * 0.55;
//   const width = desktopCondition
//     ? window.innerWidth * 0.7
//     : window.innerWidth * 0.95;
//   const props = {
//     showProgressDetails: false,
//     proudlyDisplayPoweredByUppy: false,
//     logger: debugLogger,
//     disableInformer: true,
//     width: width,
//     height: height,
//     fileManagerSelectionType: "both",
//     trigger: ".test",
//     hideUploadButton: true,
//     hidePauseResumeButton: true,
//     locale: {
//       strings: {
//         pauseUpload: "Pause upload",
//         cancelUpload: "Cancel upload",
//         retryUpload: "Retry upload",
//         uploadPaused: getTextByKey("upload-paused-text"),
//         uploadComplete: getTextByKey("upload-complete-uploader-text"),
//         cancel: getTextByKey("remove-all"),
//         pause: "Pause",
//         resume: "Resume",
//         retry: getTextByKey("upload-retry-uploader-text"),
//         hideCancelButton: true,
//         paused: getTextByKey("paused-upload-text"),
//         uploadFailed: parse(getTextByKey("upload-failed-uploader-text")),
//         uploading: getTextByKey("uploading-upload-text"),
//         complete: getTextByKey("complete-upload-text"),
//         dropHint: "Drop your files here",
//         dropPasteBoth: "",
//         addMore: getTextByKey("add-more-files-upload-text"),
//         uploadingXFiles: {
//           0: getTextByKey("send-single-file-text"), //getTextByKey("send-single-file-text"),
//           1: getTextByKey("send-multiple-files-text"), //getTextByKey("send-multiple-files-text"),
//         },
//         back: getTextByKey("back-text"),
//         addingMoreFiles: getTextByKey("add-more-files-text"),
//         xFilesSelected: {
//           0: getTextByKey("selected-single-file-text"),
//           1: getTextByKey("selected-multiple-files-text"),
//         },
//         filesUploadedOfTotal: {
//           0: getTextByKey(""),
//           1: getTextByKey(""),
//         },
//       },
//     },
//   };
//   //files-uploaded-of-total-uploader
//   //checking if some files exist
//   const [moreThan0, setMoreThan0] = useState(false);
//   useEffect(() => {
//     if (uppy.getFiles().length > 0) {
//       setMoreThan0(true);
//       uppy.getFiles().forEach((file) => {
//         uppy.setFileMeta(file.id, {
//           encryptedFileName: `${uuidv4()}.${file.extension}`,
//         });
//       });
//     } else {
//       setMoreThan0(false);
//     }
//   }, [uppy.getFiles().length]);

//   useEffect(() => {
//     const elem = document.getElementById("add-files-folders-buttons-wrapper");
//     if ((!desktopCondition || embedMailId) && moreThan0 && !uploading) {
//       renderAddFilesFolderButtons();
//       const elem = document.getElementById("add-files-folders-buttons-wrapper");
//       const root = ReactDOM.createRoot(elem);
//       root.render(
//         <>
//           <Icon name={"home/add_files"} onClick={handleAddFiles} blue />
//           <Icon name={"home/add_folder"} onClick={handleAddFolders} blue />
//         </>
//       );
//     }
//     if ((!moreThan0 || uploading) && elem) {
//       const root = ReactDOM.createRoot(elem);
//       root.unmount();
//     }
//   }, [moreThan0, uploading]);

//   const openModalMailDetails = () => {
//     setModal({
//       modal: EditMailDetailsModal,
//       props: {
//         encryptedMailId: encryptMailId,
//         setModalOpen: setModalOpen,
//       },
//     });
//     setModalOpen(true);
//   };
//   // setModal({
//   //   modal: EmbedDynamicExample,
//   //   modalSize: "full-modal",
//   //   //container: DefaultContainerNoClose,
//   //   props: {
//   //     selectedForm: form,
//   //     previewMode: true,
//   //   },
//   // }),
//   const embedModalHandler = (result) => {
//     setModal({
//       modal: EmbedErrorsModal,
//       container: DefaultContainerNoClose,
//       modalSize: "full-modal",
//       props: {
//         typeError: result,
//         embedDetails: embedFormDetails,
//       },
//     });
//   };

//   const modalHandler = useCallback(
//     ({ isSaved }) => {
//       setModal({
//         modal: LimitSizeModal,
//         modalSize: " uploader-modal",
//         props: {
//           mailId: encryptMailId,
//           size: size,
//           isSaved: isSaved,
//           setConfirmCode: setConfirmCode,
//           uploadStart: (code) =>
//             beforeUploadHandler({
//               files: uppy.getFiles(),
//               mailId: encryptMailId,
//               lang: getLanguageCulture(),
//               userMail: getUserData().UserName,
//               totalSize: size,
//               uppy: uppy,
//               code: code,
//               server: server,
//             }),
//         },
//       });
//     },
//     [size, server]
//   );

//   // handle render upload button
//   const handleRenderUploadButton = () => {
//     uploadButtonRender({
//       buttonValue: getTextByKey("upload-send"),
//       mailId: encryptMailId,
//       userdId: getUserData().UserId,
//       uppy: uppy,
//       files: uppy.getFiles(),
//       modalHandler: modalHandler,
//       lang: getLanguageCulture(),
//       userMail: getUserData().UserName,
//       isEmbed: !!embedMailId,
//       embedFormDetails: embedFormDetails,
//       embedModalHandler: embedModalHandler,
//       server: server,
//     });
//   };

//   const filesCountRef = useRef(0);
//   useEffect(() => {
//     // filesCountref will be equal to uppy.getFiles().length when user trying to select files which are already selected
//     if (filesCountRef.current === uppy.getFiles().length && moreThan0) {
//       handleRenderUploadButton();
//     }
//     filesCountRef.current = uppy.getFiles().length;
//   }, [uppy.getFiles(), moreThan0]);

//   useEffect(() => {
//     if (moreThan0) {
//       setFilesExist(true);
//       handleRenderUploadButton();
//     } else {
//       setFilesExist(false);
//       renderCustomDragAndDtopTitle({
//         title: getTextByKey(
//           !desktopCondition || embedMailId
//             ? "uploader-dropzone-title-mobile"
//             : "uploader-dropzone-title"
//         ),
//         text: getTextByKey("uploader-dropzone-text"),
//         clickAction: handleAddFiles,
//       });
//     }
//   }, [moreThan0, getUserData().UserId, size, server]);

//   useEffect(() => {
//     if (!moreThan0) {
//       setHasFolders(false);
//     }
//   }, [moreThan0]);

//   const checkHealthServer = async () => {
//     const serverLink = await checkUplaoderConnection();
//     // replace "/health" with "/uploads"
//     // new upadate replacing with "/files/"
//     if (serverLink) {
//       const serverLinkUploads = serverLink.replace("/health", "/uploads");
//       setServer(serverLinkUploads);
//       // uppy.use(Tus, {
//       //   endpoint: serverLinkUploads, // use your tus endpoint here
//       //   retryDelays: [0, 1000, 3000, 5000],
//       //   storeFingerprintForResuming: false,
//       //   // chunkSize: Infinity
//       // });
//     } else {
//       setModal({
//         modal: ConnectionUploaderIssue,
//         props: {
//           mailId: mailId,
//         },
//       });
//     }
//   };

//   useEffect(() => {
//     checkHealthServer();
//   }, []);

//   // show size near send files button
//   const handleShowSize = () => {
//     setTimeout(() => {
//       const condition = desktopCondition && !embedMailId;
//       const elem = document.querySelector(
//         condition ? ".uppy-StatusBar" : ".uppy-DashboardContent-title"
//       );
//       if (elem) {
//         const loadingElem = document.querySelector(".loading-files");
//         if (loadingElem) {
//           loadingElem.parentElement.removeChild(loadingElem);
//         }
//         const sizeElem = document.querySelector(".files-size");
//         const sizeValue =
//           (condition ? "" : ", ") +
//           bytesToDisplayHelper(size).size +
//           bytesToDisplayHelper(size).type;
//         if (sizeElem) {
//           sizeElem.innerHTML =
//             bytesToDisplayHelper(size).size === 0 ? "" : sizeValue;
//         } else {
//           const newSize = document.createElement("div");
//           newSize.className = "files-size";
//           newSize.innerHTML =
//             bytesToDisplayHelper(size).size === 0 ? "" : sizeValue;
//           if (condition) {
//             elem.prepend(newSize);
//           } else {
//             elem.appendChild(newSize);
//           }
//         }
//       }
//       uploadInfo.updateSize(size);
//     }, 100);
//   };
//   useEffect(() => {
//     handleShowSize();
//   }, [size]);

//   const visibilityTab = () => {
//     if (document.hidden) {
//       setIsActive(false);
//     } else {
//       setIsActive(true);
//     }
//   };

//   useEffect(() => {
//     const func = () => {
//       clearInterval(intervalId);
//     };
//     window.addEventListener("beforeunload", func);
//     document.addEventListener("visibilitychange", visibilityTab);

//     return () => {
//       window.removeEventListener("beforeunload", func);
//       document.removeEventListener("visibilitychange", visibilityTab);
//       clearInterval(intervalId);
//     };
//   }, []);

//   useEffect(() => {
//     window.addEventListener("offline", () => {
//       document.querySelector(".uppy-StatusBar-actions").style.display = "none";
//       uppy.pauseAll();
//       setModal({
//         modal: SimpleContent,
//         props: {
//           title: "Your coonnection have been lost",
//           message:
//             "Please check your internet connection and your upload process will continue autmatically as soon as you will be online.",
//         },
//       });
//     });
//     window.addEventListener("online", () => {
//       closeModal();
//       document.querySelector(".uppy-StatusBar-actions").style.display =
//         "initial";
//       uppy.resumeAll();
//     });
//   }, []);

//   const dragEnter = () => {
//     if (uploading) return;
//     const elem = document.querySelector(".uppy-StatusBar");
//     if (elem) {
//       const sizeElem = document.querySelector(".loading-files");
//       const filesSize = document.querySelector(".files-size");
//       const buttonFilesSize = document.querySelector(".uppy-StatusBar-actions");
//       if (filesSize) {
//         filesSize.innerHTML = "";
//       }
//       if (buttonFilesSize) {
//         buttonFilesSize.innerHTML = "";
//       }
//       if (sizeElem) {
//         sizeElem.innerHTML =
//           '<span class="image-loading"><img src=' +
//           loader +
//           ' alt="" title="" /></span><span class="text">' +
//           getTextByKey("loading-files-text-uploader") +
//           "</span>";
//       } else {
//         const newSize = document.createElement("div");
//         newSize.className = "loading-files";
//         newSize.innerHTML =
//           '<span class="image-loading"><img src=' +
//           loader +
//           ' alt="" title="" /></span><span class="text">' +
//           getTextByKey("loading-files-text-uploader") +
//           "</span>";
//         elem.prepend(newSize);
//       }
//     }
//   };

//   // coockies settings to check if user have new uplaode
//   const updateCookie = () => {
//     if (window.location.href.includes("test.jumbomail")) {
//       removeCookies("Test-NewUploader");
//       setCookies("Test-NewUploader", false, {
//         path: "/",
//         domain: ".jumbomail.me",
//       });
//     } else {
//       removeCookies("NewUploader");
//       setCookies("NewUploader", false, {
//         path: "/",
//         domain: ".jumbomail.me",
//       });
//     }
//   };
//   //embedMailId
//   useEffect(() => {
//     if (filesCount === totalFilesCount.current && !modalOpen) {
//       setTimeout(() => {
//         if (embedMailId) {
//           embedUploadCompleteHandler({
//             files: uppy.getFiles(),
//             mailId: encryptMailId,
//             lang: getLanguageCulture(),
//             userMail: getUserData().UserName,
//             token,
//             langPath: getPath(),
//             code: confirmCode,
//             setFinishUpload: setFinishUpload,
//             setItsDone,
//           });
//         } else {
//           uploadCompleteHandler({
//             files: uppy.getFiles(),
//             mailId: mailId,
//             lang: getLanguageCulture(),
//             userMail: getUserData().UserName,
//             token,
//             langPath: getPath(),
//             code: confirmCode,
//             setItsDone,
//           });
//         }
//       }, 3000);
//       uploadSuccessLoaderImage();
//       clearInterval(intervalId);
//     }
//   }, [filesCount, modalOpen]);

//   useEffect(() => {
//     if (errStatus) {
//       errorHandler({
//         mailId: encryptMailId,
//         errorMessage: errStatus,
//       });
//     }
//   }, [errStatus]);

//   const uppyStatusBar = document.querySelector(".uppy-StatusBar");
//   const buttonsSatusBar = document.querySelector(".uppy-StatusBar-actionBtn");
//   useEffect(() => {
//     if (uppyStatusBar && embedDesign && embedDesign.backgroundColor) {
//       uppyStatusBar.style.backgroundColor = embedDesign.backgroundColor;
//     }
//     if (embedDesign && embedDesign.buttonsColor && buttonsSatusBar) {
//       buttonsSatusBar.style.backgroundColor = embedDesign.buttonsColor;
//     }
//   }, [embedDesign, uppyStatusBar, buttonsSatusBar]);

//   return (
//     <>
//       <div className="chosen-users-alert">
//         {parse(getTextByKey("beta-selected-users-text"))}
//       </div>
//       <div className="uploader-functional-header">
//         {embedMailId ? (
//           <div className="embed-header">
//             <h1>{getTextByKey("select-files-embed-uploader")}</h1>
//             <p>{getTextByKey("select-files-embed-uploader-text")}</p>
//           </div>
//         ) : (
//           <>
//             <div
//               className="settings-mail"
//               onClick={() => {
//                 openModalMailDetails();
//               }}
//             >
//               <span className="text">
//                 {getTextByKey("edit-mail-details-uploader")}
//               </span>
//             </div>
//             <div
//               className="switch-old-uploader"
//               onClick={() => {
//                 updateCookie();
//               }}
//             >
//             </div>
//           </>
//         )}
//       </div>
//       <Dashboard onDragEnter={dragEnter} uppy={uppy} {...props} />
//       {filesExist && desktopCondition && !embedMailId ? (
//         uploading ? null : (
//           <>
//             {hasFolders && (
//               <div className="folder-noti">
//                 {getTextByKey("has-folders-noti")}
//               </div>
//             )}
//             <div className="jm-upload-footer-container text-noti">
//               <Icon name="cloud-upload-solid" gray />
//               {getHtmlByKey("use-drag-and-drop")}
//             </div>
//           </>
//         )
//       ) : uploading ? null : filesExist &&
//         (!desktopCondition || embedMailId) ? (
//         <div className="jm-upload-footer-container text-noti">
//           {getHtmlByKey("use-drag-and-drop-mobile")}
//         </div>
//       ) : (
//         <div className="jm-upload-footer-container">
//           <div className="add-buttons-container">
//             <Button onClick={handleAddFiles} blank>
//               {getTextByKey("add-files-uploader")}{" "}
//               <Icon name="file-alt-solid" blue />
//             </Button>
//             <Button onClick={handleAddFolders} blank>
//               {getTextByKey("add-folder-uploader")}{" "}
//               <Icon name="folder-alt-solid" blue />
//             </Button>
//           </div>
//         </div>
//       )}
//       {/* {process.env.REACT_APP_STAGE === "prod " ? null : (
//         <div className="logger">
//           {
//             <div className="options">
//               {Object.keys(log).map((item) => {
//                 return (
//                   <div
//                     onClick={() => {
//                       setCurrentLog(item);
//                     }}
//                     className={item === currentLog ? "selected" : ""}
//                   >
//                     {item}
//                   </div>
//                 );
//               })}
//             </div>
//           }
//           {log[currentLog].map((item, i) => {
//             return (
//               <div className="log-item">
//                 {i}: {item}
//               </div>
//             );
//           })}
//         </div>
//       )} */}
//     </>
//   );
// };

const FalseComponent = () => null;
export default FalseComponent;
